import { createSelector } from 'reselect';
import { RootState } from '../state';
import { UserRoles } from '../../shared/models/user';

export const selectUpdateUserState = (state: RootState) => state?.userManagement?.updateUser;
export const selectUsersState = (state: RootState) => state?.userManagement?.users?.data;

export const selectSavingUserStatus = createSelector(
  selectUpdateUserState,
  (state) => state?.saving,
)

export const selectLoadingUserStatus = createSelector(
  selectUpdateUserState,
  (state) => state?.loading,
)

export const selectSavedUserStatus = createSelector(
  selectUpdateUserState,
  (state) => state?.saved,
)

export const selectUpdatingUser = createSelector(
  selectUpdateUserState,
  (state) => state?.user,
)

export const selectTechnicians = createSelector(
  selectUsersState,
  (state) => state?.
    filter(user => user.roles.includes(UserRoles.Agent)).
    filter(user => !user.removed),
);

export const selectTechniciansIncludingRemoved = createSelector(
  selectUsersState,
  (state) => state?.filter(user => user.roles.includes(UserRoles.Agent)),
);

export const selectRemovedTechnicians = createSelector(
  selectUsersState,
  (state) => state?.
  filter(user => user.roles.includes(UserRoles.Agent)).
  filter(user => user.removed),
);

export const selectAgentCount = createSelector(
  selectTechnicians,
  state => state?.length || 0,
);

export const selectOrgAdmin = createSelector(
  selectUsersState,
  state => state?.filter(user => user.roles.includes(UserRoles.Admin))?.[0],
);
